import React from 'react';
import { Link } from "react-router-dom";
import { Divider, Icon, LinkText, Typography } from "../ecosystem";

const AppointmentOverviewItem = ({
    children,
    isMobile,
    label,
    status,
    url
}) => {

    const labelType = isMobile ? "body-01" : "body-02";
    const isCompleted = status?.toLowerCase() === 'completed' ? true : false;
    const isActive = status?.toLowerCase() === 'active' ? true : false;
    const labelColor = isCompleted ? '$color-primary-a3' : '';
    const content = <>
        <div className="info-wrapper__details-text">
            {
                isCompleted
                    ? <LinkText
                        typographyType={labelType}
                        as={<div></div>}
                    >
                        {label}
                    </LinkText> :
                    <Typography
                        type={labelType}
                        color={labelColor}
                    >
                        {label}
                    </Typography>
            }

            {children &&
                <div className="sub-details-wrapper">
                    <Typography
                        type={labelType}
                        tag="div"
                    >
                        {children}
                    </Typography>
                </div>
            }
        </div>
        {(isCompleted || isActive) &&
            <div className="info-wrapper__details-icon">
                {isCompleted
                    ? <><LinkText
                        typographyType="body-02"
                        as={<span></span>}
                    >
                        Edit
                    </LinkText> <Icon name="check" color={"$color-system-a1"} /></>
                    : <Icon name="edit" color={"$color-secondary-a2"} />
                }
            </div>
        }
    </>;


    return (<>
        <div className="info-wrapper">
            {isCompleted
                ? <Link className="info-wrapper__details" to={url}>
                    {content}
                </Link>
                : <div className="info-wrapper__details">
                    {content}
                </div>
            }
            
            <Divider mTop="none" mBottom="none" mLeft="none" mRight="none" />
        </div>
    </>);
}

export default AppointmentOverviewItem;

